import React from 'react';
import styled from 'styled-components';
import { FilePdfOutlined, FileWordOutlined, FileExcelOutlined, FileImageOutlined, LinkOutlined, PaperClipOutlined, FileTextOutlined } from '@ant-design/icons';
import { AttachmentFileType } from '../../enums';
import { AttachmentItemComponent } from './components/attachment-item.component';
import { styleVariables } from '@lib/common'; // ─── Styled Components ────────────────────────────────────────────────────────

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var ListWrapper = styled.div.withConfig({
  displayName: "attachment-listcontainer__ListWrapper",
  componentId: "sc-1l96y1l-0"
})(["display:flex;align-items:center;gap:8px;padding:12px 16px 8px;background-color:#fff;overflow-x:auto;white-space:nowrap;&::-webkit-scrollbar{height:4px;}&::-webkit-scrollbar-track{background:transparent;}&::-webkit-scrollbar-thumb{background:#e0e4ef;border-radius:4px;}&::-webkit-scrollbar-thumb:hover{background:#c8cdd8;}"]); // ─── Resolver Logic ───────────────────────────────────────────────────────────

export var resolveAttachmentMeta = function resolveAttachmentMeta(fileType) {
  switch (fileType) {
    case AttachmentFileType.PDF_DOCUMENT:
      return {
        icon: /*#__PURE__*/_jsx(FilePdfOutlined, {}),
        typeLabel: 'PDF DOCUMENT',
        color: '#e53935'
      };

    case AttachmentFileType.WORD_DOCUMENT:
      return {
        icon: /*#__PURE__*/_jsx(FileWordOutlined, {}),
        typeLabel: 'WORD DOCUMENT',
        color: '#1565c0'
      };

    case AttachmentFileType.SPREADSHEET:
      return {
        icon: /*#__PURE__*/_jsx(FileExcelOutlined, {}),
        typeLabel: 'SPREADSHEET',
        color: '#2e7d32'
      };

    case AttachmentFileType.IMAGE:
      return {
        icon: /*#__PURE__*/_jsx(FileImageOutlined, {}),
        typeLabel: 'IMAGE',
        color: '#6a1b9a'
      };

    case AttachmentFileType.WEB_LINK:
      return {
        icon: /*#__PURE__*/_jsx(LinkOutlined, {}),
        typeLabel: 'WEB LINK',
        color: '#0277bd'
      };

    case AttachmentFileType.FILE:
    default:
      return {
        icon: /*#__PURE__*/_jsx(PaperClipOutlined, {}),
        typeLabel: 'FILE',
        color: '#546e7a'
      };
  }
};
/**
 * Utility to guess AttachmentFileType from a raw File object or a fallback URL.
 */

export var resolveAttachmentFileType = function resolveAttachmentFileType(file, url) {
  if (file) {
    var mime = file.type;
    if (mime.includes('pdf')) return AttachmentFileType.PDF_DOCUMENT;
    if (mime.includes('word') || mime.includes('document')) return AttachmentFileType.WORD_DOCUMENT;
    if (mime.includes('excel') || mime.includes('spreadsheet')) return AttachmentFileType.SPREADSHEET;
    if (mime.startsWith('image/')) return AttachmentFileType.IMAGE;
    return AttachmentFileType.FILE;
  }

  if (url) {
    return AttachmentFileType.WEB_LINK;
  }

  return AttachmentFileType.FILE;
}; // ─── Component ────────────────────────────────────────────────────────────────

export var AttachmentListContainer = function AttachmentListContainer(_ref) {
  var attachments = _ref.attachments,
      extraFiles = _ref.extraFiles,
      onRemoveInternal = _ref.onRemoveInternal,
      onRemoveExtra = _ref.onRemoveExtra;
  var hasInternal = attachments && attachments.length > 0;
  var hasExtra = extraFiles && extraFiles.length > 0;

  if (!hasInternal && !hasExtra) {
    return null;
  }

  return /*#__PURE__*/_jsxs(ListWrapper, {
    children: [attachments === null || attachments === void 0 ? void 0 : attachments.map(function (item) {
      var meta = resolveAttachmentMeta(item.fileType);
      return /*#__PURE__*/_jsx(AttachmentItemComponent, {
        variant: "compact",
        icon: meta.icon,
        iconColor: meta.color,
        type: meta.typeLabel,
        name: item.name,
        url: item.url,
        onRemove: function onRemove() {
          return onRemoveInternal(item.id);
        }
      }, "internal-".concat(item.id));
    }), extraFiles === null || extraFiles === void 0 ? void 0 : extraFiles.map(function (item) {
      var _item$icon;

      return /*#__PURE__*/_jsx(AttachmentItemComponent, {
        variant: "compact",
        icon: (_item$icon = item.icon) !== null && _item$icon !== void 0 ? _item$icon : /*#__PURE__*/_jsx(FileTextOutlined, {}),
        iconColor: styleVariables.colors.colorPrimaryBase,
        name: item.title,
        type: item.type,
        url: item.url,
        onRemove: function onRemove() {
          return onRemoveExtra(item.id);
        }
      }, "extra-".concat(item.id));
    })]
  });
};